import dayjs from 'dayjs'
import React from 'react'
import Select from 'react-select'
import 'dayjs/locale/fr'

import { BigCalendarHeaderICalendarExport } from './components/BigCalendarHeaderExportButton'
import {
  BigCalendarHeaderICalendarImport,
  BigCalendarHeaderICalendarImportProps,
} from './components/BigCalendarHeaderImportButton'
import { bigCalendarHeaderStyle } from '../../utils/big-calendar.styles'
import { BigCalendarMonth, useBigCalendar } from '../../utils/use-big-calendar'
import { Icon } from '../../../../../../../atoms'

type BigCalendarHeaderProps = BigCalendarHeaderICalendarImportProps & {
  currentMonth: BigCalendarMonth
  onChange: (calendarMonth: BigCalendarMonth) => void
}
export const BigCalendarHeader = ({
  onChange,
  currentMonth,
  house,
  onUpdateICalendarUrls,
}: BigCalendarHeaderProps) => {
  const { calendarMonths } = useBigCalendar()

  const handleOnChange = (calendarMonth: BigCalendarMonth): void => {
    onChange(calendarMonth)
  }

  const filteredOptions = calendarMonths.filter(
    ({ id }) => id !== currentMonth.id,
  )

  return (
    <div className='flex items-center justify-between border-b border-grey-400 p-4'>
      <Select
        value={{
          label: currentMonth.label,
          value: dayjs(currentMonth.date).format('MMYYYY'),
        }}
        options={filteredOptions.map((calendarMonth) => {
          return { value: calendarMonth, label: calendarMonth.label }
        })}
        onChange={(newValue: unknown) => {
          const { value } = newValue as { value: BigCalendarMonth }

          handleOnChange(value)
        }}
        isSearchable={false}
        getOptionValue={(option) => option.key}
        components={{
          DropdownIndicator: () => (
            <Icon name='arrow-down-filled' size={12} className='mr-2' />
          ),
        }}
        styles={bigCalendarHeaderStyle()}
      />

      <div className='flex gap-4'>
        <BigCalendarHeaderICalendarImport
          house={house}
          onUpdateICalendarUrls={onUpdateICalendarUrls}
        />
        <BigCalendarHeaderICalendarExport house={house} />
      </div>
    </div>
  )
}
